import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import TextInput from '../../../../../../App/Components/Form/TextInput/TextInput'

import style from './style.scss'

type Props = {
  isMultipleChoice: boolean
  currentChoiceTypeInput: string[]
  setChoiceTypeInput: (newValue: string[]) => void
}

export const ChoiceTypeField = ({
  isMultipleChoice,
  currentChoiceTypeInput,
  setChoiceTypeInput,
}: Props) => {
  const { t } = useTranslation()

  const templateTextForAdd: string = t('Add option ')
  const [stringStorageForEdit, setStringStorageForEdit] = useState<string[]>(
    currentChoiceTypeInput,
  )
  const [fallbackText, setFallbackText] = useState<string>('')

  const addChoice = () => {
    const newChoices = [
      ...stringStorageForEdit,
      templateTextForAdd + (choiceList.length + 1),
    ]
    setStringStorageForEdit(newChoices)
    setChoiceTypeInput(newChoices)
  }

  const updateChoice = (index: number, newValue: string) => {
    const newChoices = [...stringStorageForEdit]
    newChoices[index] = newValue
    setStringStorageForEdit(newChoices)

    return newChoices
  }

  const deleteChoice = (index: number) => {
    const modifyArray = [...stringStorageForEdit]
    modifyArray.splice(index, 1)
    setChoiceTypeInput(modifyArray)
  }

  const onBlur = (index: number, newValue: string, oldFallbackText: string) => {
    if (newValue === '') {
      updateChoice(index, oldFallbackText)
      return
    }

    setChoiceTypeInput(updateChoice(index, newValue))
  }

  const choiceList = stringStorageForEdit.map((inputVal, index) => {
    const choiceTypeField = (fieldProps: { type: string }) => {
      const inputType = fieldProps.type === 'checkbox' ? 'checkbox' : 'radio'

      return (
        <div className={style.choiceQuestion} key={`choiceQuestion + ${index}`}>
          <input
            className={style.choiceButton}
            type={inputType}
            name={'inputButton'}
            value={inputVal}
          />
          <TextInput
            value={inputVal}
            onChange={e => updateChoice(index, e.target.value)}
            onBlur={e => {
              onBlur(index, e.target.value, fallbackText)
            }}
            onFocus={e => setFallbackText(e.target.value)}
          />
          <div className={style.choiceDelete}>
            <div onClick={() => deleteChoice(index)}>X</div>
          </div>
        </div>
      )
    }

    return isMultipleChoice
      ? choiceTypeField({ type: 'checkbox' })
      : choiceTypeField({ type: 'radio' })
  })

  // Return list of questions + option to add new one
  return (
    <div className={style.choiceWrapper} key={'choiceContainer'}>
      {choiceList}
      <div className={style.choiceAddButton}>
        <TextInput
          value={templateTextForAdd}
          onClick={() => addChoice()}
          isReadOnly
        />
      </div>
    </div>
  )
}
